import { IExperimentsState } from '../../types/redux/experiments';

export const defaultState: IExperimentsState = [];

export function experimentsReducer(state: IExperimentsState = defaultState): IExperimentsState {
  return state;
}
